import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { CircularProgress, Box } from '@mui/material';

interface GuidanceRouteProps {
  children: React.ReactNode;
}

export const GuidanceRoute: React.FC<GuidanceRouteProps> = ({ children }) => {
  const { user, loading } = useUser();
  const location = useLocation();

  if (loading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Redirect non-guidance users to Dashboard
  if (!user?.isGuidanceUser) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

